import { render, staticRenderFns } from "./TransactionState.vue?vue&type=template&id=56b9041b&"
import script from "./TransactionState.vue?vue&type=script&lang=ts&"
export * from "./TransactionState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports